// extracted by mini-css-extract-plugin
export default {"label":"Cv_label__wLPKN","input":"Cv_input__mV1iR","focus":"Cv_focus__YjH+J"};